import { Typography } from "@mui/material";

import { useLearning } from "../hooks/useLearning";

export function Summary() {
	const { currentBooking } = useLearning();

	if (!currentBooking) {
		return null;
	}

	return (
		<div className="summary-container item-separator-big">
			<div className="summary-info-container">
				<div>
					<Typography className="normal-text bold">Air Hours</Typography>
					<Typography className="normal-text">
						{`${currentBooking.airHours.toFixed(1)} hrs`}
					</Typography>
				</div>
				<div>
					<Typography className="normal-text bold">Simulator Hours</Typography>
					<Typography className="normal-text">
						{`${currentBooking.simulatorHours.toFixed(1)} hrs`}
					</Typography>
				</div>
				<div>
					<Typography className="normal-text bold">Miles Flown</Typography>
					<Typography className="normal-text">
						{`${currentBooking.milesFlown} mi`}
					</Typography>
				</div>
			</div>
			<div className="item-separator-small">
				<Typography className="normal-text bold">Instructor Notes</Typography>
				<Typography className="normal-text" whiteSpace="break-spaces">
					{currentBooking.flightSummary}
				</Typography>
			</div>
		</div>
	);
}
